import { useAppSelector } from 'app/hooks';
import { JobItem } from 'domains/workspaceDomain';

export enum JobCartTypeEnum {
  NOT_IN_CART = 'NOT_IN_CART',
  IN_ORDER_LATER = 'IN_ORDER_LATER',
  IN_ORDER_NOW = 'IN_ORDER_NOW',
}

export const useJobCart = (jobData: JobItem): JobCartTypeEnum => {
  const cart = useAppSelector((state) => state.cart);
  const jobInOrderLater = cart.cartLaterIds.some((item) => item === jobData.id);
  const jobInOrderNow = cart.cartNowIds.some((item) => item === jobData.id);
  console.log(
    'Job ID:',
    jobData.id,
    ' In Order Now:',
    jobInOrderNow,
    ' In Order Later:',
    jobInOrderLater
  );
  if (jobInOrderNow) {
    return JobCartTypeEnum.IN_ORDER_NOW;
  } else if (jobInOrderLater) {
    return JobCartTypeEnum.IN_ORDER_LATER;
  } else {
    return JobCartTypeEnum.NOT_IN_CART;
  }
};
